import React, { FC } from 'react';
import { formatAccount } from 'utils/generic';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import CardsCarouselContainer from './CardsCarouselContainer';
import { useGetAccountQuery } from 'lib/services';

const CardsContainer: FC = () => {
    const { data, isFetching, error } = useGetAccountQuery();

    return (
        <PageContainer center className="cards-container">
            <DataCheck
                data={data}
                isLoading={isFetching}
                error={error}
                noDataMessage="You currently have no cards"
            >
                {data && (
                    <CardsCarouselContainer account={formatAccount(data)} />
                )}
            </DataCheck>
        </PageContainer>
    );
};

export default CardsContainer;
